<template>
  <section id="habHFAssociation"
    :class="{'bgLight pretty-top': (state?.availabelStatusSection?.indexOf('hasHabitatSection'))%2 === 0,
    'pretty-top-light': state?.availabelStatusSection?.indexOf('hasHabitatSection') === 0 && !toShowOverviewTab,
    'pretty-bottom': state?.availabelStatusSection?.indexOf('hasHFSection') === -1 }" class="section"  v-if="state?.tsn && state?.hasHabitatSection">
    <div class="container has-text-centered condensed">
      <div class="columns">
        <div class="column">
          <h2>{{ $t("profile.ABStatus.habHFAssociation.sectionHeader") }}</h2>
          <div class="profile richtext bold" v-html="sppContent?.WebHabitat"></div>
        </div>
      </div>
    </div>
    <div class="container">
      <hr/>
      <div class="column">
        <!-- full model forested v-if="state?.isForestModel === dataModel.full" -->
        <div v-if="state?.isForestModel === dataModel.full"  >
          <h3 class="has-text-centered" v-html='$t("profile.ABStatus.habHFAssociation.vegChart."+ taxonCategroyName + "header", { sppName: state?.sppName })'></h3>
          <forest-spp-abundance-chart :is-species="true"/>

          <div class="">
            <figure class="">
              <div v-html='$t("profile.ABStatus.habHFAssociation.vegChart." + taxonCategroyName + "caption", { sppName: state?.sppName, regionType })'/>
            </figure>
          </div>

          <div class="no-margin-top narrow-div">
            <div class="interpretion" v-html="sppContent?.WebForestedRegionGraphText"/>
          </div>
          <div class="button-container">
            <a :href="$t('profile.ABStatus.habHFAssociation.vegChart.downloadLink')" target="_blank" class="button is-primary">{{ $t("common.downloadButtonText")}}</a>
          </div>
        </div>
        <div v-if="state?.isForestModel === dataModel.few">
          <h3 class="has-text-centered">{{ $t("profile.ABStatus.habHFAssociation.vegFewChart.header", {regionType: 'Forested'}) }} </h3>
          <few-detection-chart :isNorth="true" :is-species="true" />
          <div class="columns is-centered">
            <div class="no-margin-top no-margin-bottom" :class="{'narrow-div': state?.isPrairieModel !== dataModel.full || state?.isForestModel !== dataModel.full}">
              <figure>
                <span v-html='$t("profile.ABStatus.habHFAssociation.vegFewChart.caption", {regionType: "Forested"})'/>
                <span v-if="state.isBird" class="ml-1" v-html='$t("profile.ABStatus.habHFAssociation.vegFewChart.birdNote2023")'/>
              </figure>
            </div>
          </div>
          <div class="button-container" v-if="state?.isPrairieModel !== dataModel.few">
            <a :href="$t('profile.ABStatus.habHFAssociation.vegFewChart.downloadLink')" target="_blank" class="button is-primary">{{ $t("common.downloadButtonText")}}</a>
          </div>
        </div>
      </div>
      <hr v-if="state?.isPrairieModel !== dataModel.basic && state?.isForestModel !== dataModel.basic" />
      <div class="column" v-if="state?.isPrairieModel === dataModel.full">
        <prarie-treed-non-treed-sub-section :is-species="true" />
        <div class="button-container">
          <a :href="$t('profile.ABStatus.habHFAssociation.vegChart.downloadLink')" target="_blank" class="button is-primary">{{ $t("common.downloadButtonText")}}</a>
        </div>
      </div>
      <div class="column" v-if="state?.isPrairieModel === dataModel.few">
        <h3 class="has-text-centered">{{ $t("profile.ABStatus.habHFAssociation.vegFewChart.header", {regionType: 'Prairie'}) }} </h3>
        <few-detection-chart :isNorth="false" :is-species="true" />
        <div class="columns is-centered">
          <div class="column no-margin-top" :class="{'narrow-div': state?.isPrairieModel !== dataModel.full || state?.isForestModel !== dataModel.full}">
            <figure>
              <span v-html='$t("profile.ABStatus.habHFAssociation.vegFewChart.caption", {regionType: "Prairie"})'/>
              <span v-if="state.isBird" class="ml-1" v-html=' $t("profile.ABStatus.habHFAssociation.vegFewChart.birdNote2023")'/>
            </figure>
          </div>
        </div>
        <div class="button-container">
          <a :href="$t('profile.ABStatus.habHFAssociation.vegFewChart.downloadLink')" target="_blank" class="button is-primary">{{ $t("common.downloadButtonText")}}</a>
        </div>
      </div>
    </div>
  </section>

</template>

<script>
import ForestSppAbundanceChart from './ForestSppAbundanceChart.vue';
import FewDetectionChart from './FewDetectionChart.vue';
import { DATA_MODEL as dataModel } from '@/config/profile-config';
import { useApp } from '@/composables/state/profileState';
import PrarieTreedNonTreedSubSection from './PrarieTreedNonTreedSubSection.vue';

export default {
  components: { ForestSppAbundanceChart, FewDetectionChart, PrarieTreedNonTreedSubSection },
  name: 'AB-status-habitat-hf-section',
  setup () {
    const { state, sppContent, toShowOverviewTab, taxonCategroyName } = useApp();
    return {
      state,
      toShowOverviewTab,
      sppContent,
      dataModel,
      taxonCategroyName
    }
  }
}
</script>

<style>
.no-margin-top {
  margin-top: 0!important;
  padding-top: 0;
}
.no-margin-bottom {
  margin-bottom: 0!important;
  padding-bottom: 0;
}
.narrow-div {
  margin: 0 10%!important;
}
.interpretion ul {
  margin-top: 0px;
}
.button-container {
  display: flex;
  justify-content: flex-end;
  padding-top: 0;
}
.button-container a {
  font-size: .6rem !important;
  height: 2rem !important;
  min-height: 2rem !important;
  padding: 0.5rem 1rem !important;
  margin-top: 1rem !important;
}
</style>
